import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DateFormate } from "../helpers/CommonHelpers";
import { getAllTopics } from "../redux/slices/hotTopics/actions";

export default function SearchSuggestions({ searchQuery, setShowSearchSuggestion, isPublicSearch }) {
  const dispatch = useDispatch();
  const autocompleteResults = useSelector(
    (state) => state.search.autocompleteResults
  );
  const autocompleteLoading = useSelector(
    (state) => state.search.autocompleteLoading
  );
  const hotTopicsList = useSelector((state) => state.hotTopics.hotTopicsList);
  const searchOptions = useSelector(state => state.search.searchOptions);

  const getUpdatedUrl = (param) => {
    return `${window.location.origin}${param}`;
  };

  useEffect(() => {
    dispatch(getAllTopics());
  }, []);

  const getcontentTypeName = (type) => {
    switch (type) {
      case "analyst_reports":
        return (
          <span className="directions-badge analyst-report">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Analyst Report</span>
          </span>
        );
      case "charts_illustrations":
        return (
          <span className="directions-badge analyst-report">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">
              Charts &amp; Illustrations
            </span>
          </span>
        );
      case "in_brief":
        return (
          <span className="directions-badge analyst-report">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">In Brief</span>
          </span>
        );
      case "sidebar":
        return (
          <span className="directions-badge analyst-report">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Sidebar</span>
          </span>
        );
      case "deep_dives":
        return (
          <span className="directions-badge analyst-report">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Deep Dive</span>
          </span>
        );
      case "webinars":
        return (
          <span className="directions-badge webinar">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Webinar</span>
          </span>
        );
      case "post":
        return (
          <span className="directions-badge blog">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Blog</span>
          </span>
        );
      case "webinars":
        return (
          <span className="directions-badge webinar">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Webinar</span>
          </span>
        );
      case "roadmaps":
        return (
          <span className="directions-badge roadmap">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Roadmap</span>
          </span>
        );
      case "content_groups":
        return (
          <span className="directions-badge roadmap">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Roadmap</span>
          </span>
        );
      case "infographics":
        return (
          <span className="directions-badge infographic">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Infographic</span>
          </span>
        );
      case "podcasts":
        return (
          <span className="directions-badge podcast">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Podcasts</span>
          </span>
        );
        case "videos":
          return (
            <span className="directions-badge webinar">
              <span className="directions-badge-text">Videos</span>
            </span>
          );
      case "kits_collections":
        return (
          <span className="directions-badge kits_collections">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Kits &amp; Collections</span>
          </span>
        );
      case "kits_coll":
        return (
          <span className="directions-badge kits_collections">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Kits &amp; Collections</span>
          </span>
        );
      case "getting_started":
        return (
          <span className="directions-badge kits_collections">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Kits &amp; Collections</span>
          </span>
        );
      case "glossary_entry":
        return (
          <span className="directions-badge licensing-reference">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Reference</span>
          </span>
        );
      case "licensing_glossary_entry":
        return (
          <span className="directions-badge licensing-reference">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Licensing Reference</span>
          </span>
        );
      case "product_glossary_entry":
        return (
          <span className="directions-badge licensing-reference">
            <span className="directions-badge-icon">&nbsp;</span>
            <span className="directions-badge-text">Product Reference</span>
          </span>
        );
      case "product_family":
        return (
          <span className="directions-badge">
            <span className="directions-badge-text">Product Family</span>
          </span>
        );
      case "product":
        return (
          <span className="directions-badge">
            <span className="directions-badge-text">Product</span>
          </span>
        );
      case "authors_analysts":
        return (
          <span className="directions-badge">
            <span className="directions-badge-text">Authors &amp; Analysts</span>
          </span>
        );
      case "summary_subject_area":
        return (
          <span className="directions-badge">
            <span className="directions-badge-text">Subject Area</span>
          </span>
        );
        case "subject_area":
          return (
            <span className="directions-badge">
              <span className="directions-badge-text">Subject Area</span>
            </span>
          );
        case "events":
          return (
            <span className="directions-badge">
              <span className="directions-badge-text">Event</span>
            </span>
          );
      default:
        return (
          //   <span className="directions-badge">
          //     <span className="directions-badge-icon">&nbsp;</span>
          //     <span className="directions-badge-text">
          //       {type.replace(/_/g, " ")}
          //     </span>
          //   </span>
          null
        );
    }
  };

  const HighlightText = ({ text, wordToHighlight }) => {
    const highlightWord = (text, word) => {
      const escapeRegExp = (string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special characters
      };

      const escapedWord = escapeRegExp(word);
      const regex = new RegExp(`(${escapedWord})`, "gi"); // Create a case-insensitive regex for the word
      return text.replace(regex, "<b>$1</b>"); // Replace matched word with <b></b> tags
    };

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: highlightWord(text, wordToHighlight),
        }}
      />
    );
  };

  return (
    <div id="search-modal">
      <div id="search-modal-overflow">
        {autocompleteResults &&
          autocompleteResults.hits &&
          autocompleteResults.hits.length > 0 && (
            <p className="search-modal-group-title">Search Results...</p>
          )}
        <div
          className="search-modal-group d-table w-100"
          style={{ opacity: autocompleteLoading ? 0.3 : 1 }}
        >
          {autocompleteResults &&
            autocompleteResults.hits &&
            autocompleteResults.hits.length > 0 &&
            autocompleteResults.hits.map((hit) => (
              <div
                className="d-table-row position-relative"
                style={{ transform: 'rotate(0deg)' }}
                key={hit.source?.id}
              >
                <span className="search-modal-badge border-bottom">
                  {getcontentTypeName(hit.source?.contentType)}
                </span>
                <a
                  className="search-modal-title d-table-cell align-top border-bottom stretched-link"
                  href={hit.source?.link}
                >
                  <HighlightText
                    text={hit.source?.title}
                    wordToHighlight={searchQuery}
                  />
                </a>
                <span className="search-modal-date d-table-cell align-top border-bottom">
                  {hit.source?.latestDate &&
                    DateFormate(hit.source?.latestDate, "MMMM dd, yyyy")}
                </span>
              </div>
            ))}

          {searchQuery && searchQuery !== "" ? (
            <div className="search-modal-badge d-table-row position-relative" style={{ transform: 'rotate(0deg)' }}>
              <span className="search-modal-badge d-table-cell align-top border-bottom"></span>
              <a
                className="search-modal-title d-table-cell align-top border-bottom stretched-link"
                href={isPublicSearch ? `/search?q=${searchQuery}` : `/atlas/search?q=${searchQuery}`}
              >
                See all results for “{searchQuery}”
              </a>
              <span className="search-modal-date d-table-cell align-top border-bottom"></span>
            </div>
          ) : null}
        </div>
        {autocompleteLoading ? (
          <img
            className="search-loading"
            src="/wp-content/themes/dom/assets/img/loader.gif"
            alt="Loading..."
          />
        ) : null}
      </div>
      {!isPublicSearch && (
        <div
          id="search-modal-sticky"
          className="d-block position-relative py-2 border-top"
        >
          <p id="search-modal-sticky-title">Trending products identified by experts</p>
          <div
            id="search-modal-slider"
            className="d-block overflow-auto position-relative"
          >
            <div className="d-flex text-nowrap gap-2 px-4 py-1">
              {hotTopicsList &&
                hotTopicsList?.map((item, index) => (
                  <a
                    href={getUpdatedUrl(item?.searchTerm)}
                    key={index}
                    className="text-decoration-none"
                  >
                    {item?.viewableText}
                  </a>
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
